import { compile as compilePath } from 'path-to-regexp';

export function isUrlActive(
  basePath: string,
  currentLocationPath: string = window.location.pathname,
  exact: boolean = false
) {
  if (exact) {
    return basePath === currentLocationPath;
  }

  return currentLocationPath.includes(basePath);
}

export function compileRouteUrl(
  routeUrl: string,
  pathParameters: Record<string, string | number>
): string {
  return compilePath(routeUrl === '*' ? '(.*)' : routeUrl)(pathParameters);
}

/**
 * The href to render for an externally supplied URL, or `undefined` when it must not become a
 * link. Only absolute `http:`/`https:` URLs qualify: anything else — `javascript:`, `data:`, a
 * relative path — would run script or resolve against our own origin when clicked. The returned
 * value is the parser's normalized form, so the string that was checked is the string rendered.
 */
export function safeHttpHref(url: string | null | undefined): string | undefined {
  if (url == null) return undefined;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return undefined;
  }
  return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.href : undefined;
}
